export type TeamMember = {
  id: number;
  avatar: string;
  name: string;
  title: string;
  description: string;
};

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    avatar: "/assets/brooke.png",
    name: "Brooke Worster, MD",
    title: "Chief Medical Officer",
    description:
      "A pioneering palliative care clinician and researcher, Dr. Worster is currently Director, Supportive Oncology at Jefferson Health in Philadelphia. She is a graduate of Temple University School of Medicine and completed her fellowship in palliative care and pain management at MGH Brigham and Dana Farber Cancer Center in Boston.",
  },
  {
    id: 2,
    avatar: "/assets/ben.png",
    name: "Ben Caplan, MD",
    title: "Chief Cannabis Clinician",
    description:
      "An internationally recognized cannabis clinician and educator, Dr Caplan has overseen the care of over 18,000 cannabis patients and developed protocols that have benefited tens of thousands more. He is a graduate of Tufts University School of Medicine and completed his residency in family medicine at Boston Medical Center.",
  },
  {
    id: 3,
    avatar: "/assets/emily.png",
    name: "Emily Hajjar, PharmD, BCGP",
    title: "Geriatric Clinical Pharmacist",
    description:
      "A leading clinical geriatric pharmacist and educator, Dr. Hajjar serves as Professor and Director of the Population Health Pharmacy Program at the Jefferson College of Pharmacy. She received her PharmD at Duquesne University and completed a fellowship in Geriatric Pharmacoepidemiology at the University of Minnesota.",
  },
];
